import React, { createContext, useState } from 'react';

// Create the context
export const LocationContext = createContext();

// Create the provider
export const LocationProvider = ({ children }) => {
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [changeLocation,setChangeLocation] = useState(false);

  return (
    <LocationContext.Provider value={{ locationModalOpen, setLocationModalOpen,changeLocation,setChangeLocation }}>
      {children}
    </LocationContext.Provider>
  );
};